import { S as Swiper } from './swiper-core-ClzX336E.js';
import { P as Pagination } from './pagination-BYB1eQGc.js';
import './classes-to-selector-B0Ehowsi.js';
import './create-element-if-not-defined-CpMCDYSa.js';

class ContentGridSlider extends HTMLElement {
  connectedCallback() {
    // Wait for next frame to ensure container has dimensions
    requestAnimationFrame(() => {
      this.initSwiper();
    });
  }

  initSwiper() {
    const swiperElement = this.querySelector('.swiper--content-grid');
    if (!swiperElement) {
      return;
    }

    this.slides = swiperElement ? Array.from(swiperElement.querySelectorAll('.swiper-slide')) : [];

    const loopSetting = this.dataset.loop === 'true';
    const pagination = this.dataset.pagination === 'true';

    const config = {
      modules: [Pagination],
      spaceBetween: 16,
      slidesPerView: 1.2,
      loop: loopSetting && this.slides.length > 1,
      breakpoints: {
        768: {
          slidesPerView: 2.2,
          loop: loopSetting && this.slides.length > 2,
        },
        1024: {
          slidesPerView: 3,
          loop: loopSetting && this.slides.length > 3,
        },
      },
    };

    if (loopSetting) {
      config.loop = true;
    }

    if (pagination) {
      config.pagination = {
        el: '.swiper-pagination',
        clickable: true,
      };
    }

    this.swiper = new Swiper(swiperElement, config);
  }
}

customElements.define('content-grid-slider', ContentGridSlider);
